module.exports = __webpack_public_path__ + "static/img/rubbish bin.ca68c53.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/rubbish bin.png
// module id = eOG+
// module chunks = 1